import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from 'styled-components';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { GlobalStyle, theme } from './theme/theme';
import './styles/scss/site.scss';
import registerLodashMixins from './utility/func';
import configGetter from './config';

import { Configuration, PublicClientApplication, EventType, EventMessage, AuthenticationResult, PopupRequest } from '@azure/msal-browser';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

export const msalConfig: {
  msalConfiguration: Configuration;
  msalInstance: PublicClientApplication;
  loginRequest: PopupRequest;
} = {
  msalConfiguration: null,
  msalInstance: null,
  loginRequest: null,
};

void configGetter().then((config) => {
  msalConfig.msalConfiguration = {
    auth: {
      clientId: config.clientId,
      authority: `https://login.microsoftonline.com/${config.tenantId}`,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
  };

  msalConfig.msalInstance = new PublicClientApplication(msalConfig.msalConfiguration);

  msalConfig.loginRequest = {
    scopes: config.scopes.map((x) => `api://${config.clientId}/${x}`),
  };

  const accounts = msalConfig.msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalConfig.msalInstance.setActiveAccount(accounts[0]);
  }

  msalConfig.msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalConfig.msalInstance.setActiveAccount(account);
    }
    console.log(`Callback type ${event.eventType}: ${event.error}`);
  });

  registerLodashMixins();

  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App instance={msalConfig.msalInstance} />
        </ConnectedRouter>
      </Provider>
    </ThemeProvider>,
    document.getElementById('root'),
  );

  registerServiceWorker();
});
